import { getCartTitle } from 'common/helpers/miscHelper';

const Loading = (props) => {
  const { cart, settings } = props;
  const title = getCartTitle(settings);
  if (cart.isFetching) {
    return (
      <>
        <div className="c7-cart__loading">
          <div className="c7-cart__loading__animation">
            <div />
            <div />
            <div />
            <div />
          </div>
          Updating your {title.toLowerCase()}
        </div>
      </>
    );
  }
  return null;
};

export default Loading;
